export default {
    resultadoBuscaTodosOrcamentosFicha: {
        filtros: {
            conteudo: {
                default: null,
                label: 'Pesquisa',
                value: ''
            },
            pacienteId: {
                default: null,
                label: null,
                value: ''
            }
        },
        paginacao: {
            page: 1,
            size: 10,
            sort: 'id',
            direction: 'DESC',
        }
    },
}